
import './App.css';
import Footer from './components/Footer/Footer';
import { Hero } from './components/Hero';
import Join from './components/Join/Join';
import Plans from './components/Plans/Plans';
import Programs from './components/Programs/Programs';
import Reasons from './components/Reasons/Reasons';
import Testomonial from './components/Testomonial/Testomonial';
function App() {
  return (
    <div className="App">
         <Hero/>
         <Programs/>
         <Reasons/>
         <Plans/>
         <Testomonial/>
         <Join/>
         <Footer/>
    </div>
  );
}

export default App;
